import NewAddressForm from "./NewAddressForm";

const Address = () => {
  return (
    <>
      <div className=" mt-3 mb-3 d-flex justify-content-center align-items-center gap-3 p-4">
        <div className=" w-100">
          <div
            className=" border-dashed p-3 add-address border-radius-0 cursor-pointer"
            data-bs-toggle="collapse"
            data-bs-target="#collapseNewAddress"
            aria-expanded="true"
            aria-controls="collapseNewAddress"
          >
            <div>
              <div>
                <i className="bi bi-plus-circle-fill fs-4 opacity-6"></i>
              </div>
              <b className=" text-black-50 fw-bold fs-5">Add Address</b>
            </div>
          </div>
        </div>
        <div className=" w-100">
          <div className=" card shadow-card p-1 border-1 border-radius-0">
            <div className=" card-header border-bottom">
              <b className=" text-black">
                <i className="bi bi-patch-check-fill text-success me-1"></i>
                Default
              </b>
            </div>
            <div className=" card-body lh-sm">
              <div>
                <b className=" text-black fw-bolder text-xl">Siddharth</b>
              </div>
              <div>
                <b className=" text-black fw-normal text-sm">
                  D.No. 6-8-778, First Floor
                </b>
              </div>
              <div>
                <b className=" text-black fw-normal text-sm">
                  KB Layout (Sanjeevayi Nagar)
                </b>
              </div>
              <div>
                <b className=" text-black fw-normal text-sm">
                  TIRUPATI, ANDHRA PRADESH 517501
                </b>
              </div>
              <div>
                <b className=" text-black fw-normal text-sm">India</b>
              </div>
              <div>
                <b className=" text-black fw-normal text-sm">
                  Phone number: +91 8919180171
                </b>
              </div>
              <div>
                <a
                  href="."
                  className=" text-black fw-normal text-xs me-1 text-decoration-line"
                >
                  Add delivery instructions
                </a>
              </div>
            </div>
            <div className=" card-footer border-top">
              <div className=" d-flex justify-content-start align-items-center gap-2">
                <div className="mt-1">
                  <a
                    href="."
                    className=" text-black fw-normal text-xs me-1 text-decoration-line"
                  >
                    Edit
                  </a>
                </div>
                <span className=" text-gray opacity-7">|</span>
                <div className="mt-1">
                  <a
                    href="."
                    className=" text-black fw-normal text-xs me-1 text-decoration-line"
                  >
                    Remove
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" w-100">
          <div className=" card shadow-card p-1 border-1 border-radius-0">
            <div className=" card-header border-bottom">
              <b className=" text-black">Address - 1</b>
            </div>
            <div className=" card-body lh-sm">
              <div>
                <b className=" text-black fw-bolder text-xl">Siddharth</b>
              </div>
              <div>
                <b className=" text-black fw-normal text-sm">
                  D.No. 6-8-778, First Floor
                </b>
              </div>
              <div>
                <b className=" text-black fw-normal text-sm">
                  KB Layout (Sanjeevayi Nagar)
                </b>
              </div>
              <div>
                <b className=" text-black fw-normal text-sm">
                  TIRUPATI, ANDHRA PRADESH 517501
                </b>
              </div>
              <div>
                <b className=" text-black fw-normal text-sm">India</b>
              </div>
              <div>
                <b className=" text-black fw-normal text-sm">
                  Phone number: +91 8919180171
                </b>
              </div>
              <div>
                <a
                  href="."
                  className=" text-black fw-normal text-xs me-1 text-decoration-line"
                >
                  Add delivery instructions
                </a>
              </div>
            </div>
            <div className=" card-footer border-top">
              <div className=" d-flex justify-content-start align-items-center gap-2">
                <div className="mt-1">
                  <a
                    href="."
                    className=" text-black fw-normal text-xs me-1 text-decoration-line"
                  >
                    Edit
                  </a>
                </div>
                <span className=" text-gray opacity-7">|</span>
                <div className="mt-1">
                  <a
                    href="."
                    className=" text-black fw-normal text-xs me-1 text-decoration-line"
                  >
                    Remove
                  </a>
                </div>
                <span className=" text-gray opacity-7">|</span>
                <div className="mt-1">
                  <a
                    href="."
                    className=" text-black fw-normal text-xs me-1 text-decoration-line"
                  >
                    Set as default
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="collapseNewAddress"
        className="accordion-collapse collapse"
        aria-labelledby="address"
        data-bs-parent="#accordionNewAddress"
      >
        <div className="accordion-body ">
          <div className=" w-80 p-3 border border-radius-0 ms-4">
            <NewAddressForm />
          </div>
        </div>
      </div>
    </>
  );
};

export default Address;
